module.exports = {
	CATALOGS: {
		legacy: "legacy"
	},
	// ALL COLLECTION FROM DB NAME
	COLLECTIONS: {
		ACCOUNT: "accountConfig"
	}
};
